import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import App from './App/index';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';
import * as serviceWorker from './serviceWorker';
import reducer from './store/reducer';
import './App.css';
const store = createStore(reducer);

const app = (
    <Provider store={store}>
        <BrowserRouter basename={process.env.REACT_APP_ROUTE_FLAG}>
            {/* basename="/API_BASE_URL" */}
            <App />
        </BrowserRouter>
        <ToastContainer/>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
